import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    maxWidth: '100%',
    boxShadow: 'none',
    '& > div:first-child': {
      left: 0,
    },
    '& > div:last-child': {
      right: 0,
    },
  },
  tabRoot: {
    padding: 0,
    opacity: 1,
    maxWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      minWidth: 'auto',
    },
  },
  tab: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    padding: 15,
    fontSize: 16,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    background: '#fff',
    borderRight: '1px solid rgba(112, 112, 112, .24)',
    color: theme.custom.darkBlue,
    cursor: 'pointer',
    textTransform: 'none',
    '&:last-child': {
      borderRight: 0,
    },
  },
  active: {
    background: theme.custom.darkBlue,
    border: 0,
    color: '#fff',
    cursor: 'default',
  },
  labelIcon: {
    minHeight: 'auto',
    '& .MuiTab-wrapper > *:first-child': {
      marginLeft: 10,
      marginBottom: 0,
      color: theme.custom.warning,
    },
  },
  activeIcon: {
    background: '#fff',
    borderRadius: '50%',
  },
  textColorInherit: {
    opacity: 1,
  },
  scrollButtons: {
    position: 'absolute',
    maxHeight: 58,
    height: '100%',
    background: '#EFF2F7',
    opacity: 1,
    zIndex: 9,
  },
  indicator: {
    display: 'none',
  },
  selected: {
    '& > .MuiTab-wrapper': {
      background: theme.custom.darkBlue,
      color: '#fff',
      '& svg': {
        background: '#fff',
        borderRadius: '50%',
      },
    },
  },
}));
